import { render, staticRenderFns } from "./ClientQuestions.vue?vue&type=template&id=1f12bd22"
import script from "./ClientQuestions.vue?vue&type=script&lang=js"
export * from "./ClientQuestions.vue?vue&type=script&lang=js"
import style0 from "./ClientQuestions.vue?vue&type=style&index=0&id=1f12bd22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports